import { ButtonBase } from '@material-ui/core';
import { ButtonProps } from '@material-ui/core/Button';
import { ButtonBaseProps } from '@material-ui/core/ButtonBase';
import React, { FC } from 'react';

import useStyles from './styles';

export type TextButtonProps = ButtonBaseProps & { color?: ButtonProps['color'] };

export const TextButton: FC<TextButtonProps> = ({ children, color = 'primary', ...otherProps }) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-assignment
  const classes = useStyles({ color });
  return (
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment
    <ButtonBase classes={{ root: classes.container }} disableRipple {...otherProps}>
      {children}
    </ButtonBase>
  );
};
